// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"ddd0d2c2","163":"addd85cf","423":"cca5cd54","476":"f507d2cf","743":"312a7074","744":"14c7cb44","933":"ca6cebab","973":"4c965ead"}[chunkId] + ".chunk.css";
};